<template>
    <table class="table table-head-fixed text-nowrap">
        <thead>
            <tr>
                <th class="pl-2 pt-2 pb-2 text-nowrap">Username</th>
                <th class="pl-2 pt-2 pb-2 text-nowrap" :style="`width: ${userActivityDetailColWidth}px !important;`">
                    Machine
                </th>
                <th class="pl-2 pt-2 pb-2 text-nowrap" :style="`width: ${userActivityDetailColWidth}px !important;`">
                    Package
                </th>
                <th class="pl-2 pt-2 pb-2 text-nowrap text-right" :style="`width: ${userActivityDetailColWidth}px !important;`">
                    Price ({{$pointNameShort}})
                </th>
                <th class="pl-2 pt-2 pb-2 text-nowrap text-right" :style="`width: ${userActivityDetailColWidth}px !important;`">
                    Uptime (hour)
                </th>
                <th class="pl-2 pt-2 pb-2 text-nowrap text-right" :style="`width: ${userActivityDetailColWidth}px !important;`">
                    Estimated ({{$pointNameShort}})
                </th>
            </tr>
        </thead>
        <tbody>
            <tr :key="element.id" v-for="(element, indexUser) in userActivityDetail">
                <td class="pl-2 pt-2 pb-2 text-nowrap">
                    <div class="d-flex align-items-center">
                        {{indexUser+1}}. <strong>{{element.username}}</strong>
                        <div class="d-flex align-items-center">
                            <img style="height: 0.6rem" class="ml-2" 
                                 :src="`/flag/${element.region}.svg`" />
                            <span class="ml-1">{{ $countryList[element.region] }}</span>
                        </div>
                    </div>
                    <div>
                        <span>Estimated: <span class="text-primary">{{element.data.reduce(function(a, b){ return a + b.estimatedPoint; }, 0) | numFormat('0,0.00')}} {{$pointNameShort}}</span></span>
                    </div>
                </td>
                <td class="p-0 v-center" colspan="5">
                    <table class="w-100  table-borderless table-striped ">
                        <tr :key="childItem.vmMachineId" v-for="childItem in element.data">
                            <td class="pl-2 pt-2 pb-2 text-nowrap"
                                :style="`width: ${userActivityDetailColWidth}px !important;`">
                                {{childItem.vmMachineId}}
                            </td>
                            <td class="pl-2 pt-2 pb-2 text-nowrap"
                                :style="`width: ${userActivityDetailColWidth}px !important;`">
                                <span v-if="listServicePackDict[childItem.packageId]">
                                    {{listServicePackDict[childItem.packageId].name}}
                                </span>
                            </td>
                            <td class="pl-2 pt-2 pb-2 text-nowrap text-right"
                                :style="`width: ${userActivityDetailColWidth}px !important;`">
                                <strong>{{childItem.priceHour | numFormat('0,0.00')}}</strong>
                            </td>
                            <td class="pl-2 pt-2 pb-2 text-nowrap text-right"
                                :style="`width: ${userActivityDetailColWidth}px !important;`">
                                <strong>{{childItem.uptimeInHours | numFormat('0,0.00')}}</strong>
                            </td>
                            <td class="pl-2 pt-2 pb-2 text-nowrap text-right"
                                :style="`width: ${userActivityDetailColWidth}px !important;`">
                                <strong>{{childItem.estimatedPoint | numFormat('0,0.00')}}</strong>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    import { mapState } from "vuex";
    import baseComponent from "@/scripts/baseComponent";
    import chartDataApi from "@/api/common/chartData";
    export default {
        extends: baseComponent,
        data() {
            return {
                userActivityDetail: [],
                userActivityDetailColWidth: 130,
                intervalRefresh: null,
            }
        },
        computed: {
            ...mapState({
                userInfo: (state) => state.auth.user,
                rolesInfo: (state) => state.auth.roles,
                listServicePack: (state) => state.common.listServicePack,
                decentralization: (state) => state.auth.decentralization,
            }),
            listServicePackDict() {
                return this.listServicePack.reduce(function (acc, cur, i) {
                    acc[cur.id] = cur;
                    return acc;
                }, {});
            },
        },
        mounted() {
            this.getUserActivityDetail();
            this.intervalRefresh = setInterval(() => {
                this.getUserActivityDetail();
            }, 5000);
        },
        beforeDestroy() {
            if (this.intervalRefresh) clearInterval(this.intervalRefresh);
        },
        methods: {
            getUserActivityDetail() {
                chartDataApi.getUserActivityDetail().then((response) => {
                    if (response.data && response.data.result === 0) {
                        let uniqueUserList = [...new Set(response.data.data.map(x => {
                            return x.username;
                        }))];
                        let uniqueUserDataList = uniqueUserList.map((x) => {
                            return {
                                username: x,
                                region: response.data.data.find(z => z.username === x).region,
                                data: response.data.data.filter(z => z.username === x),
                            };
                        });
                        this.userActivityDetail = uniqueUserDataList;
                    }
                }).catch(error => {
                    console.error(error);
                });
            },
        }
    }
</script>